import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const StyledAlertContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '12px',
  backgroundColor: '#FFF0D6',
  borderRadius: '12px',
  marginBottom: '16px'
}));

export { StyledAlertContainer };
